import { IcdCodeForReAuthPayload } from "../models/Patient";
import API from "./api";

export const IcdCodeTypeData = (baseUrl: string) =>
  API.get(`${baseUrl}api/ReferralService/DiagnosisType`);

export const diseaseTypeRespValues = (
    baseUrl: string,
    diseaseIdentifier: string
  ) => API.get(`${baseUrl}api/ReferralService/IcdDiagnosisType?searchText=${diseaseIdentifier}`);

export const GetIcdCodeForReAuth = (
    baseUrl: string,
    payload: IcdCodeForReAuthPayload
  ) => API.get(`${baseUrl}api/ReferralService/${payload.id}/${payload.typeId}`);